const SITE_CONTENT_STORAGE_KEY = 'clipstone_site_content';

const DEFAULT_SITE_CONTENT = {
  home: {
    heroTitle: 'CLIPSTONE MINERS WELFARE',
    heroDescription: 'Supporting local initiatives, heritage projects, and welfare programmes.',
    heroStatNumber: '90+',
    heroStatLabel: 'Years of History',
    trustCardTitle: 'Clipstone Miners Welfare Community Trust',
    trustCardDescription: 'Supporting local initiatives, heritage projects, and welfare programmes across the region.',
    socialCardTitle: 'Clipstone Social Club',
    socialCardDescription: 'Events, gatherings, entertainment, and social clubs bringing everyone together.',
  },
  about: {
    introOne: 'Clipstone Miners Welfare is the central hub connecting our community, social, and sports organisations. We are dedicated to supporting local initiatives, heritage projects, and welfare programmes across the region.',
    introTwo: 'Our mission is to provide a vibrant space for social interaction, sports, and community development, honouring our rich mining heritage while looking towards a sustainable future.',
    goals: 'We aim to strengthen community wellbeing, preserve local heritage, and create welcoming spaces where residents of all ages can take part in social, sporting, and cultural life.',
    achievements: 'Through ongoing events, partnerships, and local initiatives, we have helped support community activity, celebrate Clipstone’s history, and build a stronger sense of belonging for residents and visitors alike.',
    purpose: 'The purpose of Clipstone Miners Welfare is to serve the local area with care, dignity, and community spirit, ensuring that people have access to meaningful opportunities, support, and shared experiences.',
    motif: 'Our motif is rooted in the identity of Clipstone itself: resilience, heritage, neighbourliness, and a commitment to building a thriving future for the village while honouring the generations that came before us.',
  },
  community: {
    title: 'Clipstone Miners Welfare Community Page',
    mission: "This page shows you what activites are included in the Clipstone Community. You'll be able to see when these Events/Activities are available in the Home page.",
    pillars: [
      {
        title: 'Sport & Recreation',
        description: 'We provide high-quality facilities, pitches, and pavilions to support amateur sports for both adults and children, including Football (Junior & Senior), Cricket, and Bowls.',
      },
      {
        title: 'Youth Centre & Activities',
        description: 'We run a Youth Club four evenings a week, offering local youngsters a safe, constructive environment to build friendships and engage in leisure-time activities.',
      },
      {
        title: 'Friendship Club',
        description: 'Combating loneliness is a top priority. Our Friendship Club offers a warm, inviting social space for seniors to gather, chat, and share community events.',
      },
      {
        title: 'Community Hub & Social Club',
        description: 'The Welfare Institute serves as a versatile meeting point for local voluntary groups, charities, and celebrations with multiple function rooms available.',
      },
    ],
    contactLabel: 'Get Involved',
  },
  social: {
    heroTitle: 'Events, nights out, and social spaces for the community.',
    heroDescription: 'We host a range of paid events and private bookings for the building, including room hire for funerals, weddings, seasonal celebrations, family functions, club nights, and other special occasions. The space is flexible, welcoming, and suited to both smaller gatherings and larger community events.',
    sectionLabel: 'What we can offer',
    sectionTitle: 'Future social events',
    cards: [
      { title: 'Entertainment', text: 'Bands, DJs, karaoke, themed nights, and live performances for all ages.' },
      { title: 'Weddings (after-party)', text: 'Reception rooms, drinks, food, and flexible layouts for wedding after-parties and milestone celebrations.' },
      { title: 'Funeral (wake, celebration of life)', text: 'Quiet, dignified arrangements for wakes, celebrations of life, memorial services, and family gatherings.' },
      { title: 'Room Hire', text: 'Flexible indoor spaces for private functions, club bookings, and group sessions.' },
    ],
    slides: [
      { title: 'Live Music Nights', text: 'A space for local bands, tribute acts, and community showcases.', color: '#1f6f78' },
      { title: 'Family Disco', text: 'Big energy, bright lights, and a safe place for families to enjoy themselves.', color: '#8a4f9c' },
      { title: 'Weddings (after-party)', text: 'A welcoming setting for wedding after-parties, receptions, celebrations, and private gatherings.', color: '#c05f3d' },
      { title: 'Funeral (wake, celebration of life)', text: 'A calm, respectful space for wakes, celebrations of life, memorials, and family remembrance events.', color: '#4f6478' },
      { title: 'Seasonal Celebrations', text: 'Christmas parties, summer socials, and special events through the year.', color: '#2f7d4f' },
      { title: 'Private Hire', text: 'Space for birthdays, anniversaries, community groups, and special occasions.', color: '#285a8f' },
    ],
  },
  forms: {
    socialSuiteEnquiryHeroTitle: 'Suite Enquiry',
    socialSuiteEnquiryHeroSubtitle: 'Send us an enquiry about hiring a room and we\'ll get back to you with availability and details.',
    socialSuiteEnquirySectionLabel: 'Enquire',
    socialSuiteEnquirySectionTitle: 'Ask about hiring a suite',
    socialQuickEnquiryTitle: 'Have a question before booking?',
    socialQuickEnquirySubtitle: 'Tell us which suite you\'re interested in and send us a quick enquiry — or skip this and go straight to the full room-hire booking form below.',
    trustBookingFormTitle: 'Book Session',
    trustBookingFormSubtitlePrefix: 'for',
  },
  trust: {
    heroTitle: 'CLIPSTONE MINERS WELFARE TRUST',
    heroDescription: 'Supporting local initiatives, heritage projects, and welfare programmes.',
    heroStatNumber: '90+',
    heroStatLabel: 'Years of History',
    communityIntro: 'These sub-groups represent the trust’s own clubs, teams and friendship groups designed to support members and keep our institute lively and welcoming.',
    sportsIntro: 'The sports offer gives people of all ages a chance to stay active, enjoy friendly competition, and take part in healthy routines together.',
    activitiesIntro: 'These pages highlight community groups that are not owned by the trust but hold their events and sessions at our institute, creating a shared local hub.',
    communityRoleTitle: 'What this section does',
    communityRoleText: 'Our Sub-Groups are the trust-owned social club, friendship circles, cricket team, junior and adult football teams, and bowls group that meet here to build community spirit.',
    sportsRoleTitle: 'Why it matters',
    sportsRoleText: 'Sport at Clipstone brings people together through teamwork, wellbeing, and opportunities to try something new.',
    activitiesRoleTitle: 'How it supports residents',
    activitiesRoleText: 'Community Groups and Activities showcase external organisations and groups that use our facilities for gatherings, workshops, and community-led events.',
  },
  terms: {
    intro: 'By using the Clipstone Miners Welfare Trust website, you agree to the terms and conditions below.',
    allowed: [
      'Browse our site and view information about our services, events, opening hours, and community activities.',
      'Contact us using the email address or phone number provided for questions, bookings, or support.',
      'Use the site for personal, non-commercial purposes and to learn about our trust.',
      'Submit enquiries, messages, or booking requests in good faith.',
      'Share our public website content and links with others, provided you do not claim it as your own work.',
    ],
    disallowed: [
      'Use the website to send spam, abusive messages, hate speech, or any unlawful content.',
      'Attempt to access restricted areas of the site, break security, or reverse engineer the site code.',
      'Copy, reproduce, or distribute our website content for commercial use without permission.',
      'Post fake, misleading, or defamatory content through any contact forms or communications.',
      'Use the site in a way that interferes with normal operation, overloads services, or harms other users.',
    ],
    responsibilities: [
      'Provide accurate and honest information when contacting us or making a booking request.',
      'Respect our staff, volunteers, and other members of the Clipstone Miners Welfare Trust community.',
      'Follow any additional rules or guidelines provided by the Trust during events, visits, or bookings.',
      'Keep your contact details current so we can respond to your enquiries.',
    ],
    rules: [
      'We may update these terms at any time, and continued use of the site indicates acceptance of changes.',
      'The information on this site is provided for general purposes and may be changed without notice.',
      'We are not responsible for third-party links or external content linked from this site.',
      'We reserve the right to block or refuse access to anyone who violates these terms.',
    ],
    legal: 'These terms of service govern your use of the website only. Use of the website does not create any contract or agreement beyond the information shared here. For questions about these terms, please contact us via the Contact page.',
  },
  privacy: {
    intro: 'Your privacy is important to the Clipstone Miners Welfare Trust. This policy explains how we collect, use, and protect your information.',
    collect: [
      'Contact details you provide, such as name, email address, and phone number.',
      'Messages or enquiries submitted through our contact page or email.',
      'Booking information used for events, activities, or room hires.',
      'Technical data about how you use the website, including page visits and browser type.',
    ],
    use: [
      'To respond to enquiries, booking requests, and support messages.',
      'To manage events, bookings, and community activities.',
      'To improve the website and make our content easier to use.',
      'To keep you informed about Trust services if you ask us to.',
    ],
    notDo: [
      'We do not sell or rent your personal information to third parties.',
      'We do not share your data with outside organisations for marketing without your consent.',
      'We do not store more information than is necessary to provide the services you request.',
    ],
    cookies: 'Our website may use cookies or similar tools to improve navigation and understand usage patterns. These tools do not identify you personally and are only used to improve site performance.',
    rights: [
      'You can ask us to update, correct, or remove your personal information.',
      'You can request details about the information we hold about you.',
      'You can withdraw consent for communications at any time by contacting us.',
    ],
    security: 'We take reasonable steps to protect your personal information from unauthorised access and disclosure. However, no internet transmission is completely secure.',
    changes: 'We may update this policy from time to time. Continued use of the website means you accept any published changes.',
    contact: 'If you have questions about this Privacy Policy or want to access your data, please contact us via the Contact page.',
  },
};

const cloneValue = (value) => JSON.parse(JSON.stringify(value));

const safeParse = (value) => {
  if (!value) return null;

  try {
    return JSON.parse(value);
  } catch {
    return null;
  }
};

const getSiteContent = () => {
  if (typeof window === 'undefined') {
    return cloneValue(DEFAULT_SITE_CONTENT);
  }

  const stored = safeParse(window.localStorage.getItem(SITE_CONTENT_STORAGE_KEY));
  if (!stored) {
    return cloneValue(DEFAULT_SITE_CONTENT);
  }

  return {
    ...cloneValue(DEFAULT_SITE_CONTENT),
    ...stored,
    home: { ...cloneValue(DEFAULT_SITE_CONTENT.home), ...(stored.home || {}) },
    about: { ...cloneValue(DEFAULT_SITE_CONTENT.about), ...(stored.about || {}) },
    community: { ...cloneValue(DEFAULT_SITE_CONTENT.community), ...(stored.community || {}) },
    social: { ...cloneValue(DEFAULT_SITE_CONTENT.social), ...(stored.social || {}) },
    forms: { ...cloneValue(DEFAULT_SITE_CONTENT.forms), ...(stored.forms || {}) },
    trust: { ...cloneValue(DEFAULT_SITE_CONTENT.trust), ...(stored.trust || {}) },
    terms: { ...cloneValue(DEFAULT_SITE_CONTENT.terms), ...(stored.terms || {}) },
    privacy: { ...cloneValue(DEFAULT_SITE_CONTENT.privacy), ...(stored.privacy || {}) },
  };
};

const saveSiteContent = (content) => {
  window.localStorage.setItem(SITE_CONTENT_STORAGE_KEY, JSON.stringify(content));
  window.dispatchEvent(new Event('site-content-updated'));
};

const resetSiteContent = () => {
  window.localStorage.removeItem(SITE_CONTENT_STORAGE_KEY);
  window.dispatchEvent(new Event('site-content-updated'));
};

export {
  DEFAULT_SITE_CONTENT,
  getSiteContent,
  resetSiteContent,
  saveSiteContent,
};